import '../menu-bar/index';

import ToolbarController from './toolbar.controller';

angular
	.module('app.toolbar', [
		'app.menu-bar'
	])
	.component('appToolbar', {
		templateUrl:'layout/toolbar/toolbar.html',
		controller: ToolbarController
	});

